import { formatBoolean } from './format';
export const compare = props => {
  let a = props.value1;
  let b = props.value2;
  const {
    caseSensitive,
    localize,
    formatLocale
  } = props;
  const trimStringValues = props.trimStringValues === undefined ? true : props.trimStringValues;

  // can we short-circuit this whole thing?
  if (a === b) return 0;

  // DATAPREP-18694 - undefined, null and blank strings should sort lower than anything else
  if (b === undefined) return 1;
  if (a === undefined) return -1;
  if (b === null) return 1;
  if (a === null) return -1;
  if (b === '') return 1;
  if (a === '') return -1;
  if (typeof a === 'string' && typeof b === 'string') {
    let collator = props.collator;
    if (!collator) {
      const options = {
        sensitivity: caseSensitive ? 'case' : 'base'
      };
      collator = new Intl.Collator(formatLocale, options);
    }
    if (trimStringValues) {
      a = a.trim();
      b = b.trim();
    }
    return collator.compare(a, b);
  }
  if (typeof a === 'object' && typeof b === 'object' && typeof a.value === 'number' && typeof b.value === 'number') {
    a = a.value;
    b = b.value;
  }
  if (typeof a === 'object' && typeof b === 'object' && typeof a.value === 'boolean' && typeof b.value === 'boolean') {
    a = a.value ? 1 : 0;
    b = b.value ? 1 : 0;
  }
  if (typeof a === 'boolean' && typeof b === 'boolean' && localize) {
    a = formatBoolean({
      localize,
      value: a
    });
    b = formatBoolean({
      localize,
      value: b
    });
    const collator = props.collator || new Intl.Collator(formatLocale);
    return collator.compare(a, b);
  }
  return a < b ? -1 : a > b ? 1 : 0;
};
export const sortArray = props => {
  const {
    array,
    rootPropertyName,
    propertyName,
    descending,
    caseSensitive,
    localize,
    formatLocale
  } = props;
  const collator = new Intl.Collator(formatLocale, {
    sensitivity: caseSensitive ? 'case' : 'base'
  });
  array.sort(function (a, b) {
    if (rootPropertyName) {
      a = a && a[rootPropertyName] ? a[rootPropertyName] : null;
      b = b && b[rootPropertyName] ? b[rootPropertyName] : null;
    }
    if (propertyName) {
      if (a) a = a[propertyName];
      if (b) b = b[propertyName];
    }
    const rv = compare({
      formatLocale,
      value1: a,
      value2: b,
      collator,
      localize
    });
    return descending ? rv * -1 : rv;
  });
};
//# sourceMappingURL=sort.js.map